import { Injectable } from '@angular/core';
import { EntityState, EntityStore, guid, StoreConfig } from '@datorama/akita';
import { RewardsWalletItem } from './models/rewards-wallet.model';
import { MartketplaceTransferredItem } from '../marketplace/models/marketplace-transferred-item.model';

export interface RewardsWalletState extends EntityState<RewardsWalletItem> {
  transferredItems: MartketplaceTransferredItem[] | null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'rewards-wallet', idKey: 'UniqueId', cache: { ttl: 20000 } })
export class RewardsWalletStore extends EntityStore<RewardsWalletState> {
  constructor() {
    super({
      transferredItems: null,
    });
  }

  setGroupedWalletItems(walletItems: any[]) {
    let groupedWalletItems: { id: string; tempId: string; type: number }[] = [];

    walletItems.forEach((item) => {
      const id = guid();
      const isPersonalizedItem = item.CustomFields?.length > 0;
      const isAttributeItem = item.Attributes?.length > 0;

      if (isAttributeItem) {
        item.Attributes.forEach((attr: any) => {
          const attributeItems = walletItems.filter((x: any) => x.Attributes?.length > 0);
          // Find the item with the same custom field value and return the first found item in the list.
          const found: any = attributeItems.find(
            (x: any) =>
              x.Attributes.some((y: any) => y.AttributeMappingId === attr.AttributeMappingId) &&
              x.CustomFields.some((y: any) => item.CustomFields.some((z: any) => y.DisplayValue === z.DisplayValue))
          );

          if (found) {
            const foundIndex = groupedWalletItems.findIndex((temp) => temp.tempId === `${found.Id}-${found.LogId}`);
            if (foundIndex === -1) {
              this._setGroupId(item.UniqueId, id);
              groupedWalletItems.push({ tempId: `${found.Id}-${found.LogId}`, id, type: item.ItemType });
            } else {
              this._setGroupId(item.UniqueId, groupedWalletItems[foundIndex].id);
            }
          } else {
            const foundIndex = groupedWalletItems.findIndex((temp) => temp.tempId === `${item.Id}-${attr.AttributeMappingId}`);
            if (foundIndex === -1) {
              this._setGroupId(item.UniqueId, id);
              groupedWalletItems.push({ tempId: `${item.Id}-${attr.AttributeMappingId}`, id, type: item.ItemType });
            } else {
              this._setGroupId(item.UniqueId, groupedWalletItems[foundIndex].id);
            }
          }
        });
        // }
      } else if (isPersonalizedItem) {
        const customFieldItems = walletItems.filter((x: any) => x.CustomFields?.length > 0);
        // Look for same custom field value in the list and return the first found item in the list.
        const found: any = customFieldItems.find((x: any) =>
          x.CustomFields.some((y: any) => item.CustomFields.some((z: any) => y.DisplayValue === z.DisplayValue))
        );

        if (found) {
          const foundIndex = groupedWalletItems.findIndex((group) => group.tempId === `${item.Id}-${found.LogId}`);

          if (foundIndex === -1) {
            this._setGroupId(item.UniqueId, id);
            groupedWalletItems.push({ tempId: `${item.Id}-${found.LogId}`, id, type: item.ItemType });
          } else {
            this._setGroupId(item.UniqueId, groupedWalletItems[foundIndex].id);
          }
        } else {
          this._setGroupId(item.UniqueId, id);
          groupedWalletItems.push({ tempId: `${item.Id}`, id, type: item.ItemType });
        }
      } else {
        const foundIndex = groupedWalletItems.findIndex((group) => group.tempId === `${item.Id}` && group.type === item.ItemType);

        if (foundIndex === -1) {
          this._setGroupId(item.UniqueId, id);
          groupedWalletItems.push({ tempId: `${item.Id}`, id, type: item.ItemType });
        } else {
          this._setGroupId(item.UniqueId, groupedWalletItems[foundIndex].id);
        }
      }
    });
  }

  private _setGroupId(id: string, groupId: string) {
    this.update(id, { GroupId: groupId });
  }
}
